const parseApiPermissions = (permissions) => {
    return !permissions ? [] : permissions.split(',').map((v) => v.trim())
}

export default parseApiPermissions
